// src/utils.js
export function setTokens(access, refresh) {
  localStorage.setItem('access_token', access);
  localStorage.setItem('refresh_token', refresh);
}

export function getAccessToken() {
  return localStorage.getItem('access_token');
}

export function getRefreshToken() {
  return localStorage.getItem('refresh_token');
}

export async function apiRequest(url, options = {}) {
  const accessToken = getAccessToken();
  options.headers = {
    ...(options.headers || {}),
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };

  let resp = await fetch(url, options);

  if (resp.status === 401) {
    const refreshToken = getRefreshToken();
    if (refreshToken) {
      const r = await fetch(`${process.env.REACT_APP_API}/api/token/refresh/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh: refreshToken }),
      });
      if (r.ok) {
        const jr = await r.json();
        setTokens(jr.access, jr.refresh || refreshToken);
        options.headers.Authorization = `Bearer ${jr.access}`;
        resp = await fetch(url, options);
      } else {
        localStorage.clear();
        window.location.href = '/login';
        return resp;
      }
    }
  }
  return resp;
}

export async function fetchUserType(accessToken) {
  try {
    const resp = await fetch(`${process.env.REACT_APP_API}/api/user-profile/`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (!resp.ok) return null;
    const data = await resp.json();
    const uType = (data?.user_data?.user_type || '').toLowerCase() || null;
    if (uType) localStorage.setItem('user_type', uType);
    return uType;
  } catch {
    return localStorage.getItem('user_type') || null;
  }
}
